export default __webpack_public_path__ + "static/media/GraduateResearchDay_2023_RLDynamic.eaaf5a60.pdf";